import script from "./SettingsGradesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsGradesSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsGradesSection.vue?vue&type=style&index=0&id=0cec3089&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cec3089"]])

export default __exports__